export default __webpack_public_path__ + "static/media/mpg.532dcd34.svg";